<form (ngSubmit)="send()" class="sender-wrapper">
  <mat-form-field class="full-width">
    <input matInput [(ngModel)]="message" name="message" placeholder="Type your message" required>
    <button mat-icon-button matSuffix type="submit">
      <mat-icon matSuffix>send</mat-icon>
    </button>

  </mat-form-field>
</form>
